//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {}
  },
  computed: {
    preview () {
      return (
        this.value
        ? URL.createObjectURL(this.value)
        : null
      )
    }
  },
  methods: {
    handleFileChange ({ target: { files } }) {
      this.$emit('change', files[0])
    },
    handleDelete () {
      this.$refs.fileRef.value = ''
      this.$emit('change', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Wallet/AddWallet/components/ImagePicker/index.vue